import React, { memo } from 'react'
import i18n from 'atpjs/helpers/i18n'

const t = i18n.prefix(['components', 'appointmentGrid'])

const Empty = memo(() => {
  return (
    <li className="atp-time-list__holiday atp-time-list__holiday--full-day">
      <div className="atp-time-list__holiday__label">{t(['empty'])}</div>
    </li>
  )
})
Empty.displayName = 'Empty'

export default Empty
